import routes from '@/modules/country/country-routes';
import store from '@/modules/country/country-store';

export default {
  routes,
  store,
};
